export const clearSummary = ({ summariesToClear }) => {
    const productSummary = document.querySelector('.configurator_info-main-product');
    const accessoriesSummary = document.querySelector('.configurator_info-accessories');

    summariesToClear.forEach(sTC => {
        [accessoriesSummary, productSummary]
            .forEach(summary => summary
                ?.querySelectorAll(`.configurator_info.${sTC}`)
                    ?.forEach(i => i.remove())
        );
    });
}

export const resetChosenAccessory = () => {
    const accessoryInput = document.querySelector('.newSelect');
    const placeholder = accessoryInput?.querySelector('.form-select__placeholder'); 
    const selectEl = accessoryInput?.querySelector('.form-select__list');

    selectEl?.setAttribute("data-option-value", "");
    selectEl?.setAttribute("value", "");

    if (placeholder?.innerText) {
        placeholder.innerText = document.querySelector("[data-select-first-option-text]")?.dataset?.selectFirstOptionText || 'Select';
    }
}